// extracted by mini-css-extract-plugin
export var textInput = "_lp-0";